import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen } from 'lucide-react';
import { Separator } from '../../components/ui/separator';

/**
 * Shared chrome for the public blog: top bar with back-to-home, branded mark,
 * and a sticky footer with cross-links. Keeps the marketing site aesthetic
 * (premium light theme) without re-rendering the heavy <MarketingSite />.
 */
export const BlogShell = ({ children, testId = 'blog-shell' }) => (
  <div className="min-h-screen bg-[#FAFAF8] text-[#1a1a1a]" data-testid={testId}>
    <header className="sticky top-0 z-30 border-b border-black/8 bg-white/85 backdrop-blur supports-[backdrop-filter]:bg-white/70">
      <div className="max-w-[1120px] mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[13px] font-medium text-[#3a3a3a] hover:text-[#004C54] transition-colors"
          data-testid="blog-back-home"
        >
          <ArrowLeft className="h-4 w-4" />
          Apex Athletic Mind
        </Link>
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 font-mono-accent text-[10px] uppercase tracking-[0.22em] text-[#004C54] font-semibold hover:opacity-80 transition-opacity"
          data-testid="blog-shell-brand"
        >
          <BookOpen className="h-3.5 w-3.5" />
          The Apex Journal
        </Link>
      </div>
    </header>

    {children}

    <footer className="border-t border-black/8 bg-white mt-16">
      <div className="max-w-[1120px] mx-auto px-5 sm:px-8 py-10">
        <div className="grid sm:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-heading text-[15px] font-semibold mb-2">Train your mind. Elevate your game.</h3>
            <p className="text-[13.5px] text-[#5a5a5a] leading-[1.65] max-w-[42ch]">
              The Apex Journal publishes sports psychology essays for serious athletes, parents, and coaches.
            </p>
          </div>
          <div>
            <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-[#004C54] font-semibold mb-3">Train With Us</div>
            <ul className="space-y-1.5 text-[13.5px]">
              <li><Link to="/assessment" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors" data-testid="blog-footer-assessment">Take the $27 Self-Assessment</Link></li>
              <li><Link to="/quiz" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors" data-testid="blog-footer-quiz">Free Mindset Quiz</Link></li>
              <li><Link to="/playbook" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors" data-testid="blog-footer-playbook">Get the Free Playbook</Link></li>
              <li><Link to="/workshops" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors" data-testid="blog-footer-workshops">Workshops</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono-accent uppercase tracking-[0.2em] text-[10px] text-[#004C54] font-semibold mb-3">Legal</div>
            <ul className="space-y-1.5 text-[13.5px]">
              <li><Link to="/privacy" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors">Terms</Link></li>
              <li><Link to="/disclaimer" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors">Disclaimer</Link></li>
              <li><a href="/api/rss.xml" className="text-[#1a1a1a] hover:text-[#004C54] transition-colors" data-testid="blog-footer-rss">RSS Feed</a></li>
            </ul>
          </div>
        </div>
        <Separator className="bg-black/8" />
        <p className="mt-5 text-[12px] text-[#6b6b6b]">
          &copy; {new Date().getFullYear()} Apex Athletic Mind Consulting LLC. All rights reserved.
        </p>
      </div>
    </footer>
  </div>
);

export default BlogShell;
